<div class="center" [ngStyle]="{ color: color, fontSize: '12px' }">
  Appsync status
</div>
